import React from "react";
import { Row, Col, Card, Button, Image } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

const Dashboard: React.FC = () => {
  return (
    <div style={{ flex: 1, backgroundColor: "#FAFAFA" }}>
      {/* Hero Section */}
      <div style={{ margin: "30px 24px 45px 24px" }}>
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
            border: "none",
            overflow: "hidden",
          }}
          bodyStyle={{ padding: 0 }}
        >
          <Row align="middle" style={{ minHeight: "200px" }}>
            <Col xs={24} lg={16} style={{ padding: "40px" }}>
              <div
                style={{
                  color: "#777",
                  fontSize: "20px",
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  fontFamily:
                    "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                }}
              >
                City of New Orleans, Louisiana
              </div>

              <div
                style={{
                  color: "#4D4D4D",
                  fontSize: "36px",
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  lineHeight: "1",
                  marginTop: "10px",
                  fontFamily:
                    "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                }}
              >
                E-Bike Incentive Program
              </div>

              <div
                style={{
                  color: "#AAA",
                  fontSize: "18px",
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  lineHeight: "1",
                  textTransform: "uppercase",
                  marginTop: "10px",
                  fontFamily:
                    "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                }}
              >
                Bike Shop Portal
              </div>

              <Row gutter={[20, 16]} style={{ marginTop: "40px" }}>
                <Col xs={24} sm={12}>
                  <Button
                    type="primary"
                    icon={<ArrowRightOutlined />}
                    style={{
                      backgroundColor: "#DF701F",
                      borderColor: "#DF701F",
                      borderRadius: "6px",
                      height: "40px",
                      fontFamily:
                        "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                      fontSize: "16px",
                      fontWeight: "400",
                      width: "100%",
                    }}
                  >
                    Validate Incentive Code
                  </Button>
                </Col>
                <Col xs={24} sm={12}>
                  <Button
                    type="primary"
                    icon={<ArrowRightOutlined />}
                    style={{
                      backgroundColor: "#DF701F",
                      borderColor: "#DF701F",
                      borderRadius: "6px",
                      height: "40px",
                      fontFamily:
                        "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                      fontSize: "16px",
                      fontWeight: "400",
                      width: "100%",
                    }}
                  >
                    Sales In Progress
                  </Button>
                </Col>
              </Row>
            </Col>

            <Col xs={24} lg={8}>
              <Image
                src="/images/bike-hero.webp"
                alt="E-Bike Hero"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "0px 10px 10px 0px",
                }}
                preview={false}
              />
            </Col>
          </Row>
        </Card>
      </div>

      {/* Section Title */}
      <div
        style={{
          margin: "0 24px 34px 24px",
          display: "flex",
          alignItems: "center",
          gap: "23px",
        }}
      >
        <div
          style={{
            color: "#4D4D4D",
            fontFamily:
              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
            fontSize: "20px",
            fontWeight: "700",
            letterSpacing: "0.5px",
            lineHeight: "0.8",
            whiteSpace: "nowrap",
          }}
        >
          E-Bike Incentives in Your Shop
        </div>
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#CCC",
          }}
        />
      </div>

      {/* Stats Cards */}
      <div style={{ margin: "0 24px", marginBottom: "160px" }}>
        <Row gutter={[20, 20]}>
          {/* Reimbursements & Requests Card */}
          <Col xs={24} lg={12}>
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
                border: "none",
                height: "100%",
              }}
              bodyStyle={{ padding: "20px" }}
            >
              <Row gutter={20}>
                <Col xs={24} sm={12}>
                  <div
                    style={{
                      color: "#4D4D4D",
                      fontFamily:
                        "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                      fontSize: "16px",
                      fontWeight: "700",
                      letterSpacing: "0.5px",
                      lineHeight: "1",
                      marginBottom: "60px",
                    }}
                  >
                    Reimbursements & Requests
                  </div>

                  <div style={{ textAlign: "center", marginTop: "32px" }}>
                    <div
                      style={{
                        color: "#4979A7",
                        fontSize: "32px",
                        fontWeight: "700",
                        lineHeight: "0.5",
                        fontFamily:
                          "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                      }}
                    >
                      $3,500.00
                    </div>
                    <div
                      style={{
                        color: "#4D4D4D",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "1",
                        marginTop: "20px",
                        fontFamily:
                          "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                      }}
                    >
                      Reimbursed to your shop
                    </div>
                  </div>
                </Col>

                <Col xs={24} sm={12}>
                  <div style={{ marginTop: "24px" }}>
                    {/* Pending Requests */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          backgroundColor: "rgba(249, 226, 210, 1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src="/images/pending-icon.png"
                          alt="Pending"
                          width={24}
                          height={24}
                          preview={false}
                        />
                      </div>
                      <div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "20px",
                            fontWeight: "700",
                            lineHeight: "0.8",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          3
                        </div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            marginTop: "10px",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          Pending Requests
                        </div>
                      </div>
                    </div>

                    {/* Approved Requests */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          backgroundColor: "#E6F4FF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src="/images/approved-icon.png"
                          alt="Approved"
                          width={24}
                          height={24}
                          preview={false}
                        />
                      </div>
                      <div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "20px",
                            fontWeight: "700",
                            lineHeight: "0.8",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          2
                        </div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            marginTop: "10px",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          Approved Requests
                        </div>
                      </div>
                    </div>

                    {/* Funded Requests */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          backgroundColor: "#F6FFED",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src="/images/funded-icon.png"
                          alt="Funded"
                          width={24}
                          height={24}
                          preview={false}
                        />
                      </div>
                      <div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "20px",
                            fontWeight: "700",
                            lineHeight: "0.8",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          4
                        </div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            marginTop: "10px",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          Funded Requests
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>

          {/* Sales & Incentives Card */}
          <Col xs={24} lg={12}>
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
                border: "none",
                height: "100%",
              }}
              bodyStyle={{ padding: "25px" }}
            >
              <Row gutter={20}>
                <Col xs={24} sm={10}>
                  <div
                    style={{
                      color: "#4D4D4D",
                      fontFamily:
                        "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                      fontSize: "16px",
                      fontWeight: "700",
                      letterSpacing: "0.5px",
                      lineHeight: "1",
                      marginBottom: "60px",
                    }}
                  >
                    Sales & Incentives
                  </div>

                  {/* Sales In Progress */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      marginTop: "22px",
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        backgroundColor: "#FFF1F0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Image
                        src="/images/sales-icon.png"
                        alt="Sales"
                        width={24}
                        height={24}
                        preview={false}
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "20px",
                          fontWeight: "700",
                          lineHeight: "0.8",
                          fontFamily:
                            "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                        }}
                      >
                        4
                      </div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                          marginTop: "10px",
                          fontFamily:
                            "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                        }}
                      >
                        Sales In Progress
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xs={24} sm={14}>
                  <div style={{ marginTop: "53px" }}>
                    {/* Incentive Codes Validated */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        marginBottom: "40px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          backgroundColor: "#E6FFFB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src="/images/validated-icon.png"
                          alt="Validated"
                          width={24}
                          height={24}
                          preview={false}
                        />
                      </div>
                      <div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "20px",
                            fontWeight: "700",
                            lineHeight: "0.8",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          16
                        </div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            marginTop: "10px",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          Incentive Codes Validated
                        </div>
                      </div>
                    </div>

                    {/* Incentive Codes Redeemed */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          backgroundColor: "#FFFBE6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src="/images/redeemed-icon.png"
                          alt="Redeemed"
                          width={24}
                          height={24}
                          preview={false}
                        />
                      </div>
                      <div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "20px",
                            fontWeight: "700",
                            lineHeight: "0.8",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          5
                        </div>
                        <div
                          style={{
                            color: "#4D4D4D",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            marginTop: "10px",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          }}
                        >
                          Incentive Codes Redeemed
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Dashboard;
